import script from "./OrderSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./OrderSuccess.vue?vue&type=style&index=0&id=5089ebcf&lang=scss"

const __exports__ = script;

export default __exports__